module.exports = __webpack_public_path__ + "static/media/news-18.5437a3d2.jpg";